import './VibrationDetection.css';
import '../App.css';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Row, Col, Table, Button } from "react-bootstrap";

import React, { useState, useEffect, useRef } from 'react';

import { fetchEtc_list } from '../store';
import DatePicker from 'react-datepicker';


import { handleRealTimeDataJkVbV1 } from '../public/websocketHandler';

import { updateJkVbV1SettingData } from '../store'; // Redux 스토어에서 updateIvData 액션을 임포트
import { fetchSettings } from '../store';




import config from '../config';
import io from 'socket.io-client';
import axios from 'axios';











function VibrationDetection() {



  return (
    <div >

      <div className='VibrationDetection-wrap' style={{ margin: "10px" }}>

        <VibrationDetectionData />

      </div>

    </div>
  );
}









function VibrationDetectionData() {

  const audioRef = useRef(null);


  const dispatch = useDispatch();
  const JkVbV1Data = useSelector((state) => state.JkVbV1Data) || {};
  const JkVbV1SettingData = useSelector((state) => state.JkVbV1SettingData) || {};

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [alarmHistory, setAlarmHistory] = useState([]);

  const [alarmPopup, setAlarmPopup] = useState({ show: false, message: '', level: '', timestamp: '' });


  const [additionalTable, setAdditionalTable] = useState([]);
  const [isView48, setIsView48] = useState(true);
  // 알람 설정 팝업 상태 추가
  const [showAlarmSettings, setShowAlarmSettings] = useState(false);


  const [isHistoryVisible, setIsHistoryVisible] = useState(false);

  const toggleHistoryVisibility = () => {
    setIsHistoryVisible(prev => !prev);
  };




  // 비밀번호 입력 모달 상태 추가
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState('');

  // 비밀번호 확인 함수
  const handlePasswordSubmit = () => {
    if (password === 'mrt9916') {
      setShowPasswordModal(false);
      setShowAlarmSettings(true);
      setPassword(''); // 비밀번호 초기화
    } else {
      alert('비밀번호가 올바르지 않습니다.');
      setPassword(''); // 비밀번호 초기화
    }
  };

  // 버튼 클릭 핸들러 수정
  const handleAlarmSettingsClick = () => {
    setShowPasswordModal(true);
  };

  const [endDate, setEndDate] = useState(new Date());

  // fetchAlarmHistory 함수 수정
  const fetchAlarmHistory = async (startDate, endDate) => {
    try {
      // 로컬 시간대에 맞춰 날짜를 조정
      const localStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000);
      const localEndDate = new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000);

      const response = await axios.get(`${config.backendUrl}/api/JkVbV1alarms`, {
        params: {
          startDate: localStartDate.toISOString().split('T')[0],
          endDate: localEndDate.toISOString().split('T')[0]
        }
      });

      if (response.data.status === 'success') {
        setAlarmHistory(response.data.data);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert('데이터를 가져오는 데 실패했습니다.');
    }
  };

  // 상태 추가

  // useEffect 수정 (자동 조회 제거)
  useEffect(() => {
    // 페이지 로드시 자동 조회 제거
  }, []);














  // 실시간 데이터 업데이트를 위한 useEffect
  useEffect(() => {
    if (!JkVbV1Data || !JkVbV1Data.seq || !Array.isArray(additionalTable)) return;

    setAdditionalTable(prevTable => {
      return prevTable.map(row => {
        const id = Math.floor((row.id - 1) / 4) + 1;
        const channelIndex = (row.id - 1) % 4;
        const dataIndex = JkVbV1Data.Id?.findIndex(dataId => dataId === id);

        if (dataIndex === -1) return row;

        return {
          ...row,
          data: [
            JkVbV1Data.Ax[dataIndex]?.[channelIndex] ?? 0,
            JkVbV1Data.Ay[dataIndex]?.[channelIndex] ?? 0,
            JkVbV1Data.Az[dataIndex]?.[channelIndex] ?? 0,
            JkVbV1Data.Yx[dataIndex]?.[channelIndex] ?? 0,
            JkVbV1Data.Yy[dataIndex]?.[channelIndex] ?? 0,
            JkVbV1Data.Yz[dataIndex]?.[channelIndex] ?? 0,
          ],
          vibration: JkVbV1Data.Vibration[dataIndex]?.[channelIndex] ?? 0
        };
      });
    });
  }, [JkVbV1Data, additionalTable.length]); // additionalTable.length를 의존성 배열에 추가



  useEffect(() => {
    dispatch(fetchSettings()); // 데이터도 다시 불러오기 실행
  }, []);


  // 행 클릭 핸들러

  // 기존의 handleRowClick 함수
  const handleRowClick = (rowData) => {
    if (!rowData) return;

    //console.log("Row clicked:", rowData);
    //console.log("Current additionalTable:", additionalTable);

    const newRow = {
      id: rowData.id,
      data: [
        rowData.data[0],
        rowData.data[1],
        rowData.data[2],
        rowData.data[3],
        rowData.data[4],
        rowData.data[5]
      ],
      vibration: rowData.vibration
    };

    setAdditionalTable(prev => {
      const isDuplicate = prev.some(row => row.id === newRow.id);
      if (!isDuplicate) {
        //console.log("Adding new row:", newRow);
        return [...prev, newRow];
      }
      return prev;
    });
  };

  // 초기화 핸들러
  const handleReset = () => {
    setAdditionalTable([]);
  };

  // 디버깅용 useEffect
  useEffect(() => {
    //console.log("additionalTable updated:", additionalTable);
  }, [additionalTable]);


  useEffect(() => {
    const socket = io(`${config.backendUrl}`, {
      transports: ['websocket']
    });

    socket.on("connect", () => {
      // console.log("Connected to WebSocket server from JkVbV1Data");
      socket.emit("request_time");
    });

    socket.on("real_time_data_JkVbV1", (message) => {
      // console.log("real_time_data_JkVbV1", message);
      handleRealTimeDataJkVbV1(message, dispatch);
    });

    socket.on("real_time_data_JkVbV1_alarm", (message) => {
      // console.log("real_time_data_JkVbV1_alarm", message);
      setAlarmPopup({ show: true, ...message });
    });



    return () => {
      socket.off("real_time_data_JkVbV1_alarm");
      socket.off("real_time_data_JkVbV1");
      socket.off("connect");
      socket.close();
    };
  }, [dispatch]);


  const toggleView = () => {
    setIsView48((prev) => !prev);
  };


  // const handleClose = () => setAlarmPopup({ ...alarmPopup, show: false });






  // CSV 다운로드 함수 추가
  const downloadCSV = () => {
    if (alarmHistory.length === 0) {
      alert('다운로드할 데이터가 없습니다.');
      return;
    }

    // CSV 헤더
    const headers = ['발생시간', '레벨', '메시지'];

    // 데이터를 CSV 형식으로 변환
    const csvData = [
      headers.join(','), // 헤더 행
      ...alarmHistory.map(alarm => [
        alarm.Time,
        alarm.Level,
        `"${alarm.Message.replace(/"/g, '""')}"` // 메시지에 쉼표나 따옴표가 있을 경우를 대비
      ].join(','))
    ].join('\n');

    // CSV 파일 생성 및 다운로드
    const blob = new Blob(['\uFEFF' + csvData], { type: 'text/csv;charset=utf-8;' }); // BOM 추가로 한글 깨짐 방지
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    // 파일명 생성 (시작일_종료일_알람이력.csv)
    const startDateStr = selectedDate.toISOString().split('T')[0];
    const endDateStr = endDate.toISOString().split('T')[0];
    const fileName = `알람이력_${startDateStr}_${endDateStr}.csv`;

    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    if (alarmPopup.show && audioRef.current) {
      audioRef.current.play()
        .then(() => {
          console.log("Audio played successfully when modal opened");
        })
        .catch(error => {
          console.error("Audio play failed:", error);
        });
    }
  }, [alarmPopup.show]);


  const handleClose = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setAlarmPopup({ ...alarmPopup, show: false });
  };



  useEffect(() => {
    if (alarmPopup.show && audioRef.current) {
      const audioElement = audioRef.current;

      const playAudio = () => {
        audioElement.play()
          .then(() => {
            console.log("Audio played successfully when modal opened");
          })
          .catch(error => {
            console.error("Audio play failed:", error);
          });
      };

      // 오디오가 끝날 때마다 다시 재생
      audioElement.onended = playAudio;

      // 처음 오디오 재생
      playAudio();
    }

    // 팝업이 닫힐 때 오디오 중지
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.onended = null; // 이벤트 핸들러 제거
      }
    };
  }, [alarmPopup.show]);


  return (

    <div>
      <div>


        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", verticalAlign: "middle", margin: "10px" }}>

          <Button onClick={toggleView} style={{ marginLeft: "10px", padding: "5px 10px", fontSize: "15px", height: "40px" }}>
            {isView48 ? "100개 보기" : "48개 보기"}
          </Button>

          <Button
            variant="primary"
            onClick={handleReset}
            style={{ marginLeft: "10px", padding: "5px 10px", fontSize: "15px", height: "40px" }}
          >
            비교하기 목록 초기화
          </Button>

          <Button
            variant="primary"
            onClick={async () => {
              try {
                const response = await axios.post(`${config.backendUrl}/api/OffsetJkVbV1`);
                dispatch(fetchEtc_list()); // 리스트 다시 불러오기
                alert("Offset 설정 성공");
              } catch (error) {
                alert("Offset 설정 실패");
              }
            }}
            style={{ marginLeft: "10px", padding: "5px 10px", fontSize: "15px", height: "40px" }}
          >
            오프셋 현재값으로 설정
          </Button>

          <Button
            variant="primary"
            onClick={handleAlarmSettingsClick}
            style={{ marginLeft: "10px", padding: "5px 10px", fontSize: "15px", height: "40px" }}
          >
            경보 설정
          </Button>

          {/* 비밀번호 입력 모달 추가 */}
          <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>비밀번호 입력</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handlePasswordSubmit();
                  }
                }}
                placeholder="비밀번호를 입력하세요"
                style={{
                  width: '100%',
                  padding: '10px',
                  marginTop: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc'
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
                취소
              </Button>
              <Button variant="primary" onClick={handlePasswordSubmit}>
                확인
              </Button>
            </Modal.Footer>
          </Modal>

          {/* 알람 설정 팝업 */}
          <AlarmSettingsPopup
            show={showAlarmSettings}
            onHide={() => setShowAlarmSettings(false)}
            JkVbV1SettingData={JkVbV1SettingData}
          />

        </div>



        {isView48 ? (
          <Vibration48Table
            tableIndex={0}
            JkVbV1Data={JkVbV1Data}
            JkVbV1SettingData={JkVbV1SettingData}  // props 추가
            handleRowClick={handleRowClick}
            rowsPerTable={12}
            additionalTable={additionalTable}
            setAdditionalTable={setAdditionalTable}
            handleReset={handleReset}
          />
        ) : (
          <Vibration100Table
            tableIndex={0}
            JkVbV1Data={JkVbV1Data}
            JkVbV1SettingData={JkVbV1SettingData}  // props 추가
            handleRowClick={handleRowClick}
            rowsPerTable={20}
            additionalTable={additionalTable}
            handleReset={handleReset}
          />
        )}




        {/* 이력 조회 버튼 */}
        <Button onClick={toggleHistoryVisibility} style={{ position: 'fixed', top: '120px', left: '20px', zIndex: 1001 }}>
          {isHistoryVisible ? '이력 조회 <<' : '이력 조회 >>'}
        </Button>

        {/* 날짜 선택기 및 이력 테이블 */}
        {isHistoryVisible && (
          <div
            style={{
              position: 'fixed',
              top: '120px',
              left: '150px',
              width: '800px',
              maxHeight: '800px',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-out',
              backgroundColor: 'white',
              boxShadow: '0 0 10px rgba(0,0,0,0.3)',
              zIndex: 1000,
              padding: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                selectsStart
                startDate={selectedDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                placeholderText="시작일"
              />
              <span>~</span>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={selectedDate}
                endDate={endDate}
                minDate={selectedDate}
                dateFormat="yyyy-MM-dd"
                placeholderText="종료일"
              />
              <Button
                onClick={() => fetchAlarmHistory(selectedDate, endDate)}
                style={{ marginLeft: '10px' }}
              >
                조회
              </Button>
              {/* CSV 다운로드 버튼 추가 */}
              <Button
                onClick={downloadCSV}
                variant="success"
                style={{ marginLeft: '10px' }}
              >
                CSV 다운로드
              </Button>
            </div>
            <div style={{ overflowY: 'auto', maxHeight: '80vh' }}>
              <Table bordered striped hover className="history-table text-center" style={{ width: '100%', fontSize: '14px', lineHeight: '1.5' }}>
                <thead>
                  <tr>
                    <th style={{ width: '100px' }}>발생시간</th>
                    <th style={{ width: '100px' }}>레벨</th>
                    <th style={{ width: '300px' }}>메시지</th>
                  </tr>
                </thead>
                <tbody>
                  {alarmHistory.length > 0 ? (
                    alarmHistory.slice().reverse().map((alarm, index) => (
                      <tr key={index} style={{ height: '25px' }}>
                        <td style={{ width: '100px' }}>{alarm.Time}</td>
                        <td style={{ width: '100px' }}>{alarm.Level}</td>
                        <td style={{ width: '300px' }}>{alarm.Message}</td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ height: '50px' }}>
                      <td colSpan="3" style={{ width: '100%' }}>데이터가 없습니다.</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        )}




        <audio ref={audioRef} src="/allam.mp3" />

        <Modal show={alarmPopup.show} onHide={handleClose} centered>

          <Modal.Header style={{ textAlign: 'center' }}>
            <div className="triangle">
              <div style={{ position: 'absolute', top: '70px', left: '-65px', fontSize: '65px', fontWeight: 'bold', color: alarmPopup.level === '주의' ? '#FFFFFF' : alarmPopup.level === '경계' ? '#FFFF00' : alarmPopup.level === '위험' ? '#FF0000' : '#000000' }}>
                {alarmPopup.level}
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontSize: '20px',
                color: '#000000',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px'
              }}>
                {alarmPopup.message.split(' - ')[0]}<br />
                {alarmPopup.message.split(' - ')[1]}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              확인완료
            </Button>
          </Modal.Footer>
        </Modal>






      </div>





    </div >






















  );
}







function getAlertStyle(level) {
  const styles = {
    severe: { backgroundColor: '#FF6B6B' },
    warning: { backgroundColor: '#FFA94D' },
    caution: { backgroundColor: '#FFE066' },
    normal: { backgroundColor: '#FFFFFF' }
  };

  return styles[level] || styles.normal;
}






function Vibration48Table({
  tableIndex,
  JkVbV1Data,
  JkVbV1SettingData,  // props 추가
  handleRowClick,
  rowsPerTable = 12,
  additionalTable,
  setAdditionalTable,
  handleReset,
}) {


  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [hoveredRow, setHoveredRow] = useState(null);




  // 전체 데이터에서 최대값 계산 함수
  const calculateMaxValues = () => {
    let maxAcceleration = 0;
    let maxAccelerationActual = 0;
    let maxTilt = 0;
    let maxTiltActual = 0;
    let maxAccelPoint = 0;
    let maxTiltPoint = 0;

    // 1~100번 포인트에 대해 계산
    for (let i = 0; i < 25; i++) {
      for (let j = 0; j < 4; j++) {
        const accelerationValues = [
          (JkVbV1Data.Ax?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroAx?.[i]?.[j] ?? 0),
          (JkVbV1Data.Ay?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroAy?.[i]?.[j] ?? 0),
          (JkVbV1Data.Az?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroAz?.[i]?.[j] ?? 0),
        ];

        const tiltValues = [
          (JkVbV1Data.Yx?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroYx?.[i]?.[j] ?? 0),
          (JkVbV1Data.Yy?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroYy?.[i]?.[j] ?? 0),
          (JkVbV1Data.Yz?.[i]?.[j] ?? 0) - (JkVbV1Data.ZeroYz?.[i]?.[j] ?? 0),
        ];

        // 절대값으로 최대값 위치 찾기
        const currentMaxAccelAbs = Math.max(...accelerationValues.map(Math.abs));
        const currentMaxTiltAbs = Math.max(...tiltValues.map(Math.abs));

        if (currentMaxAccelAbs > Math.abs(maxAcceleration)) {
          maxAcceleration = currentMaxAccelAbs;
          // 실제 값 저장 (절대값이 가장 큰 값의 원래 값)
          maxAccelerationActual = accelerationValues[
            accelerationValues.map(Math.abs).indexOf(currentMaxAccelAbs)
          ];
          maxAccelPoint = i * 4 + j + 1;
        }

        if (currentMaxTiltAbs > Math.abs(maxTilt)) {
          maxTilt = currentMaxTiltAbs;
          // 실제 값 저장 (절대값이 가장 큰 값의 원래 값)
          maxTiltActual = tiltValues[
            tiltValues.map(Math.abs).indexOf(currentMaxTiltAbs)
          ];
          maxTiltPoint = i * 4 + j + 1;
        }
      }
    }

    return {
      maxAcceleration: maxAccelerationActual / 100, // 실제 값 반환
      maxTilt: maxTiltActual / 100, // 실제 값 반환
      maxAccelPoint,
      maxTiltPoint
    };
  };

  const maxValues = calculateMaxValues();


  useEffect(() => {
    if (!JkVbV1Data || !JkVbV1Data.seq || !Array.isArray(additionalTable)) {
      return;
    }
  
    // 이전 상태와 현재 데이터를 비교하여 실제로 업데이트가 필요한 경우에만 실행
    const needsUpdate = additionalTable.some(row => {
      const id = Math.floor((row.id - 1) / 4) + 1;
      const channelIndex = (row.id - 1) % 4;
      const dataIndex = JkVbV1Data.Id?.findIndex(dataId => dataId === id);
  
      if (dataIndex === -1) return false;
  
      const currentData = [
        JkVbV1Data.Ax[dataIndex]?.[channelIndex] ?? 0,
        JkVbV1Data.Ay[dataIndex]?.[channelIndex] ?? 0,
        JkVbV1Data.Az[dataIndex]?.[channelIndex] ?? 0,
        JkVbV1Data.Yx[dataIndex]?.[channelIndex] ?? 0,
        JkVbV1Data.Yy[dataIndex]?.[channelIndex] ?? 0,
        JkVbV1Data.Yz[dataIndex]?.[channelIndex] ?? 0,
      ];
  
      return !currentData.every((value, index) => value === row.data[index]);
    });
  
    if (needsUpdate) {
      setAdditionalTable(prevTable => {
        return prevTable.map(row => {
          const id = Math.floor((row.id - 1) / 4) + 1;
          const channelIndex = (row.id - 1) % 4;
          const dataIndex = JkVbV1Data.Id?.findIndex(dataId => dataId === id);
  
          if (dataIndex === -1) return row;
  
          return {
            ...row,
            data: [
              JkVbV1Data.Ax[dataIndex]?.[channelIndex] ?? 0,
              JkVbV1Data.Ay[dataIndex]?.[channelIndex] ?? 0,
              JkVbV1Data.Az[dataIndex]?.[channelIndex] ?? 0,
              JkVbV1Data.Yx[dataIndex]?.[channelIndex] ?? 0,
              JkVbV1Data.Yy[dataIndex]?.[channelIndex] ?? 0,
              JkVbV1Data.Yz[dataIndex]?.[channelIndex] ?? 0,
            ],
            vibration: JkVbV1Data.Vibration[dataIndex]?.[channelIndex] ?? 0
          };
        });
      });
    }
  }, [JkVbV1Data]); // additionalTable을 의존성 배열에서 제거

  const handleMouseMove = (e) => {
    setTooltipPosition({
      x: e.clientX + 15,
      y: e.clientY - 10
    });
  };

  return (
    <div onMouseMove={handleMouseMove}>
      <Row>
        {[...Array(4)].map((_, tableIndex) => (
          <Col key={tableIndex} md={2}>
            <Table
              bordered
              striped
              hover
              className="main-table text-center"
              style={{
                tableLayout: "fixed",
                width: "100%",
                borderCollapse: "collapse",
                borderSpacing: "0",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#3D98DE",
                      color: "white",
                      verticalAlign: "middle",
                      borderTopLeftRadius: "10px",
                    }}
                    rowSpan="2"
                  >
                    No
                  </th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">
                    진동
                  </th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">
                    기울기
                  </th>
                  <th
                    style={{
                      backgroundColor: "#3D98DE",
                      color: "white",
                      borderTopRightRadius: "10px",
                    }}
                    colSpan="1"
                  >
                    주파수
                  </th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>HZ</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(rowsPerTable)].map((_, rowIndex) => {
                  const mappedRowIndex = rowIndex + tableIndex * rowsPerTable;
                  const id = mappedRowIndex + 1;
                  
                  // JkVbV1Data.Id 배열에서 현재 행의 id와 일치하는 인덱스 찾기
                  const dataIndex = JkVbV1Data?.Id?.indexOf(Math.ceil(id / 4));
                  const channelIndex = (id - 1) % 4;

                  let rowData = {
                    id: id,
                    data: JkVbV1Data && dataIndex < 3 ? [ // 12개(3*4)까지만 데이터가 있으므로 dataIndex는 2까지만
                      (JkVbV1Data.Ax?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Ay?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Az?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAz?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yx?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yy?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yz?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYz?.[dataIndex]?.[channelIndex] ?? 0),
                    ] : [0, 0, 0, 0, 0, 0],
                    vibration: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.Vibration?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                    ZeroData: {
                      ZeroAx: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroAx?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                      ZeroAy: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroAy?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                      ZeroAz: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroAz?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                      ZeroYx: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroYx?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                      ZeroYy: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroYy?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                      ZeroYz: JkVbV1Data && dataIndex < 3 ? JkVbV1Data.ZeroYz?.[dataIndex]?.[channelIndex] ?? 0 : 0,
                    }
                  };

                  return (
                    <tr
                      key={rowIndex}
                      onClick={() => handleRowClick(rowData)}
                      onMouseEnter={() => {
                        console.log(`Row ${rowData.id}에 마우스가 들어왔습니다.`);
                        setHoveredRow(rowData.id);
                      }}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      {/* 진동와 기울기 최대값 계산 */}
                      {(() => {


                        const accelValues = rowData.data.slice(0, 3);
                        const tiltValues = rowData.data.slice(3, 6);

                        // 각 값별로 경보 레벨 계산
                        const accelLevels = accelValues.map(value => {
                          const absValue = Math.abs(value); // 절대값으로 변환
                          if (absValue >= JkVbV1SettingData.SetLevelAHigh * 100) return 'severe';
                          if (absValue >= JkVbV1SettingData.SetLevelAMid * 100) return 'warning';
                          if (absValue >= JkVbV1SettingData.SetLevelALow * 100) return 'caution';
                          return 'normal';
                        });

                        const tiltLevels = tiltValues.map(value => {
                          const absValue = Math.abs(value); // 절대값으로 변환
                          if (absValue >= JkVbV1SettingData.SetLevelYHigh * 100) return 'severe';
                          if (absValue >= JkVbV1SettingData.SetLevelYMid * 100) return 'warning';
                          if (absValue >= JkVbV1SettingData.SetLevelYLow * 100) return 'caution';
                          return 'normal';
                        });

                        return (
                          <>
                            <td>{rowData.id}</td>
                            {accelValues.map((value, idx) => (
                              <td key={idx} style={getAlertStyle(accelLevels[idx])}>
                                {(value / 100).toFixed(2)}
                              </td>
                            ))}
                            {tiltValues.map((value, idx) => (
                              <td key={idx + 3} style={getAlertStyle(tiltLevels[idx])}>
                                {(value / 100).toFixed(2)}
                              </td>
                            ))}
                            <td style={rowData.vibration > 0 ? { backgroundColor: 'red', color: 'white' } : {}}>{rowData.vibration}</td>
                          </>
                        );
                      })()}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        ))}









        <Col md={3}>



          {/* 최대값 테이블 추가 */}
          <div style={{ marginBottom: "0px", textAlign: "center", display: "flex", justifyContent: "center" }}>
            <Table
              bordered
              striped
              hover
              className="main-table text-center"
              style={{
                tableLayout: "fixed",
                width: "500px",
                borderCollapse: "collapse",
                borderSpacing: "0",
                marginBottom: "20px"
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#3D98DE",
                      color: "white",
                      borderTopLeftRadius: "10px",
                      width: "25%"
                    }}
                  >
                    구분
                  </th>
                  <th
                    style={{
                      backgroundColor: "#3D98DE",
                      color: "white",
                      width: "25%"
                    }}
                  >
                    최대값
                  </th>
                  <th
                    style={{
                      backgroundColor: "#3D98DE",
                      color: "white",
                      borderTopRightRadius: "10px",
                      width: "50%"
                    }}
                  >
                    발생 위치
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold" }}>최대 진동</td>
                  <td>{maxValues.maxAcceleration.toFixed(2)}</td>
                  <td>{maxValues.maxAccelPoint}번 포인트</td>
                </tr>
                <tr>
                  <td style={{ borderBottomLeftRadius: "10px", fontWeight: "bold" }}>최대 기울기</td>
                  <td>{maxValues.maxTilt.toFixed(2)}</td>
                  <td>{maxValues.maxTiltPoint}번 포인트</td>
                </tr>
              </tbody>
            </Table>
          </div>








          <Table
            bordered
            striped
            hover
            className="main-table text-center"
            style={{
              tableLayout: "fixed",
              width: "100%",
              borderCollapse: "collapse",
              borderSpacing: "0",
            }}
          >
            <thead>
              <tr>
                <th colSpan='8' style={{
                  fontSize: "15px",
                  backgroundColor: "#3D98DE",
                  color: "white",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}>비교목록</th>
              </tr>
              <tr>
                <th
                  style={{
                    backgroundColor: "#3D98DE",
                    color: "white",
                    verticalAlign: "middle",
                  }}
                  rowSpan="2"
                >
                  No
                </th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">
                  진동
                </th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">
                  기울기
                </th>
                <th
                  style={{
                    backgroundColor: "#3D98DE",
                    color: "white",
                  }}
                  colSpan="1"
                >
                  주파수
                </th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>HZ</th>
              </tr>
            </thead>
            <tbody>
              {additionalTable.length > 0 ? (
                additionalTable.map((row, rowIndex) => {
                  const accelValues = row.data.slice(0, 3);
                  const tiltValues = row.data.slice(3, 6);
                  const groupId = Math.ceil(row.id / 4);  // 현재 행이 속한 그룹의 ID
                  const dataIndex = JkVbV1Data?.Id?.indexOf(groupId);  // JkVbV1Data.Id에서 해당 그룹 ID의 인덱스
                  const channelIndex = (row.id - 1) % 4;  // 채널 인덱스

                  return (
                    <tr
                      key={rowIndex}
                      style={{ height: '50px', verticalAlign: 'middle' }}
                      onMouseEnter={() => setHoveredRow(row.id)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => setAdditionalTable(additionalTable.filter((_, index) => index !== rowIndex))}
                    >
                      <td style={{ fontSize: '20px', verticalAlign: 'middle' }}>{row.id}</td>
                      {accelValues.map((value, idx) => {
                        const zeroValue = JkVbV1Data[`ZeroA${['x', 'y', 'z'][idx]}`]?.[dataIndex]?.[channelIndex] ?? 0;
                        const adjustedValue = (value - zeroValue) / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelALow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx} style={{ fontSize: '20px', verticalAlign: 'middle', ...getAlertStyle(alertLevel) }}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      {tiltValues.map((value, idx) => {
                        const zeroValue = JkVbV1Data[`ZeroY${['x', 'y', 'z'][idx]}`]?.[dataIndex]?.[channelIndex] ?? 0;
                        const adjustedValue = (value - zeroValue) / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYLow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx + 3} style={{ fontSize: '20px', verticalAlign: 'middle', ...getAlertStyle(alertLevel) }}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      <td style={{ ...row.vibration > 0 ? { backgroundColor: 'red', color: 'white' } : {}, fontSize: '20px', verticalAlign: 'middle' }}>{row.vibration}</td>
                    </tr>
                  );
                })
              ) : (
                <tr style={{ height: '50px', verticalAlign: 'middle' }}>
                  <td colSpan="8" style={{ verticalAlign: 'middle', fontSize: '20px' }}>
                    선택된 데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>




        </Col>














      </Row>

      {hoveredRow && (
        <div
          style={{
            position: 'fixed',
            left: tooltipPosition.x,
            top: tooltipPosition.y,
            backgroundColor: '#FFD7BE',
            color: 'black',
            padding: '10px',
            borderRadius: '8px',
            zIndex: 1000,
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            fontSize: '14px',
            minWidth: '200px',
            maxWidth: '300px',
            pointerEvents: 'none'
          }}
        >
          <div style={{ textAlign: 'center' }}>Offset 설정값</div>
          {(() => {
            const groupId = Math.ceil(hoveredRow / 4);  // 현재 행이 속한 그룹의 ID
            const dataIndex = JkVbV1Data?.Id?.indexOf(groupId);  // JkVbV1Data.Id에서 해당 그룹 ID의 인덱스
            const channelIndex = (hoveredRow - 1) % 4;  // 채널 인덱스는 동일

            return dataIndex !== -1 ? (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>Ax: {(JkVbV1Data.ZeroAx?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                  <span>Ay: {(JkVbV1Data.ZeroAy?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                  <span>Az: {(JkVbV1Data.ZeroAz?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>Yx: {(JkVbV1Data.ZeroYx?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                  <span>Yy: {(JkVbV1Data.ZeroYy?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                  <span>Yz: {(JkVbV1Data.ZeroYz?.[dataIndex]?.[channelIndex] / 100).toFixed(2)}</span>
                </div>
              </>
            ) : null;
          })()}
        </div>
      )}
    </div>
  );
}






























































function Vibration100Table({ tableIndex, JkVbV1Data, JkVbV1SettingData, handleRowClick, rowsPerTable = 20, additionalTable, handleReset }) {
  const calculateMaxValues = () => {
    let maxAcceleration = 0;
    let maxTilt = 0;
    let maxAccelPoint = 0;
    let maxTiltPoint = 0;

    JkVbV1Data?.Id?.forEach((groupId, dataIndex) => {
      for (let j = 0; j < 4; j++) {
        const accelerationValues = [
          (JkVbV1Data.Ax?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroAx?.[dataIndex]?.[j] ?? 0),
          (JkVbV1Data.Ay?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroAy?.[dataIndex]?.[j] ?? 0),
          (JkVbV1Data.Az?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroAz?.[dataIndex]?.[j] ?? 0),
        ];

        const tiltValues = [
          (JkVbV1Data.Yx?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroYx?.[dataIndex]?.[j] ?? 0),
          (JkVbV1Data.Yy?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroYy?.[dataIndex]?.[j] ?? 0),
          (JkVbV1Data.Yz?.[dataIndex]?.[j] ?? 0) - (JkVbV1Data.ZeroYz?.[dataIndex]?.[j] ?? 0),
        ];

        const currentMaxAccel = Math.max(...accelerationValues.map(Math.abs));
        const currentMaxTilt = Math.max(...tiltValues.map(Math.abs));

        const currentPoint = ((groupId - 1) * 4) + j + 1;

        if (currentMaxAccel > maxAcceleration) {
          maxAcceleration = currentMaxAccel;
          maxAccelPoint = currentPoint;
        }

        if (currentMaxTilt > maxTilt) {
          maxTilt = currentMaxTilt;
          maxTiltPoint = currentPoint;
        }
      }
    });

    return {
      maxAcceleration: maxAcceleration / 100,
      maxTilt: maxTilt / 100,
      maxAccelPoint,
      maxTiltPoint
    };
  };

  const maxValues = calculateMaxValues();

  return (
    <div>
      <Row>
        {[...Array(5)].map((_, tableIndex) => (
          <Col key={tableIndex} md={2}>
            <Table bordered striped hover className="main-table text-center" 
              style={{
                tableLayout: "fixed",
                width: "280px",
                borderCollapse: "collapse",
                borderSpacing: "0",
              }}>
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#3D98DE", color: "white", verticalAlign: "middle", borderTopLeftRadius: "5px" }} rowSpan="2">No</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">진동</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">기울기</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white", borderTopRightRadius: "5px" }} colSpan="1">주파수</th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white" }}>HZ</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(20)].map((_, rowIndex) => {
                  const currentId = tableIndex * 20 + rowIndex + 1;
                  const groupId = Math.ceil(currentId / 4);
                  const dataIndex = JkVbV1Data?.Id?.indexOf(groupId);
                  const channelIndex = (currentId - 1) % 4;

                  if (dataIndex === -1) {
                    return (
                      <tr key={rowIndex}>
                        <td style={{ fontSize: '10px', verticalAlign: 'middle' }}>{currentId}</td>
                        {[...Array(7)].map((_, i) => (
                          <td key={i}>0.00</td>
                        ))}
                      </tr>
                    );
                  }

                  let rowData = {
                    id: currentId,
                    data: [
                      (JkVbV1Data.Ax?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Ay?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Az?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAz?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yx?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yy?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yz?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYz?.[dataIndex]?.[channelIndex] ?? 0),
                    ],
                    vibration: JkVbV1Data.Vibration?.[dataIndex]?.[channelIndex] ?? 0
                  };

                  return (
                    <tr key={rowIndex} onClick={() => handleRowClick(rowData)}>
                      <td style={{ fontSize: '10px', verticalAlign: 'middle' }}>{rowData.id}</td>
                      {rowData.data.slice(0, 3).map((value, idx) => {
                        const adjustedValue = value / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelALow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx} style={getAlertStyle(alertLevel)}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      {rowData.data.slice(3, 6).map((value, idx) => {
                        const adjustedValue = value / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYLow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx + 3} style={getAlertStyle(alertLevel)}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      <td style={rowData.vibration > 0 ? { backgroundColor: 'red', color: 'white' } : {}}>
                        {rowData.vibration}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        ))}

        <Col md={2}>
          <div style={{ marginBottom: "0px", textAlign: "center", display: "flex", justifyContent: "center" }}>
            <Table bordered striped hover className="main-table text-center"
              style={{
                tableLayout: "fixed",
                width: "270px",
                borderCollapse: "collapse",
                borderSpacing: "0",
                marginBottom: "20px"
              }}>
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#3D98DE", color: "white", borderTopLeftRadius: "10px", width: "25%" }}>구분</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white", width: "25%" }}>최대값</th>
                  <th style={{ backgroundColor: "#3D98DE", color: "white", borderTopRightRadius: "10px", width: "50%" }}>발생 위치</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold" }}>최대 진동</td>
                  <td>{maxValues.maxAcceleration.toFixed(2)}</td>
                  <td>{maxValues.maxAccelPoint}번 포인트</td>
                </tr>
                <tr>
                  <td style={{ borderBottomLeftRadius: "10px", fontWeight: "bold" }}>최대 기울기</td>
                  <td>{maxValues.maxTilt.toFixed(2)}</td>
                  <td>{maxValues.maxTiltPoint}번 포인트</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <Table bordered striped hover className="main-table text-center"
            style={{
              tableLayout: "fixed",
              width: "270px",
              borderCollapse: "collapse",
              borderSpacing: "0",
            }}>
            <thead>
              <tr>
                <th colSpan='8' style={{
                  fontSize: "15px",
                  backgroundColor: "#3D98DE",
                  color: "white",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}>비교목록</th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#3D98DE", color: "white", verticalAlign: "middle" }} rowSpan="2">No</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">진동</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="3">기울기</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }} colSpan="1">주파수</th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>x</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>y</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>z</th>
                <th style={{ backgroundColor: "#3D98DE", color: "white" }}>HZ</th>
              </tr>
            </thead>
            <tbody>
              {additionalTable.length > 0 ? (
                additionalTable.map((row, rowIndex) => {
                  const groupId = Math.ceil(row.id / 4);  // 현재 행이 속한 그룹의 ID
                  const dataIndex = JkVbV1Data?.Id?.indexOf(groupId);  // JkVbV1Data.Id에서 해당 그룹 ID의 인덱스
                  const channelIndex = (row.id - 1) % 4;  // 채널 인덱스

                  // 해당 ID가 JkVbV1Data.Id에 없으면 0으로 표시
                  if (dataIndex === -1) {
                    return (
                      <tr key={rowIndex}>
                        <td style={{ fontSize: '10px', verticalAlign: 'middle' }}>{row.id}</td>
                        {[...Array(7)].map((_, i) => (
                          <td key={i}>0.00</td>
                        ))}
                      </tr>
                    );
                  }

                  // JkVbV1Data에서 실제 데이터 가져오기
                  const rowData = {
                    id: row.id,
                    data: [
                      (JkVbV1Data.Ax?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Ay?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Az?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroAz?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yx?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYx?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yy?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYy?.[dataIndex]?.[channelIndex] ?? 0),
                      (JkVbV1Data.Yz?.[dataIndex]?.[channelIndex] ?? 0) - (JkVbV1Data.ZeroYz?.[dataIndex]?.[channelIndex] ?? 0),
                    ],
                    vibration: JkVbV1Data.Vibration?.[dataIndex]?.[channelIndex] ?? 0
                  };

                  const accelValues = rowData.data.slice(0, 3);
                  const tiltValues = rowData.data.slice(3, 6);

                  return (
                    <tr key={rowIndex}>
                      <td style={{ fontSize: '10px', verticalAlign: 'middle' }}>{rowData.id}</td>
                      {accelValues.map((value, idx) => {
                        const adjustedValue = value / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelAMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelALow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx} style={getAlertStyle(alertLevel)}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      {tiltValues.map((value, idx) => {
                        const adjustedValue = value / 100;
                        const alertLevel = Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYHigh`] ? 'severe' :
                          Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYMid`] ? 'warning' :
                            Math.abs(adjustedValue) >= JkVbV1SettingData[`SetLevelYLow`] ? 'caution' : 'normal';
                        return (
                          <td key={idx + 3} style={getAlertStyle(alertLevel)}>
                            {adjustedValue.toFixed(2)}
                          </td>
                        );
                      })}
                      <td style={rowData.vibration > 0 ? { backgroundColor: 'red', color: 'white' } : {}}>
                        {rowData.vibration}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8">선택된 데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
}













function AlarmSettingsPopup({ show, onHide, JkVbV1SettingData }) {
  const dispatch = useDispatch();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>경보 설정</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ marginBottom: '20px' }}>
            <div>
              <input
                type="checkbox"
                checked={JkVbV1SettingData.SetAlarmAUse === 1}
                onChange={async (e) => {
                  const value = e.target.checked ? 1 : 0;
                  dispatch(updateJkVbV1SettingData({ SetAlarmAUse: value }));
                  try {
                    const response = await axios.post(`${config.backendUrl}/api/SettingJkVbV1`, { SetAlarmAUse: value, type: 'A' });
                    alert("진동 알람 설정 성공");
                    dispatch(fetchSettings());
                  } catch (error) {
                    alert("진동 알람 설정 실패");
                  }
                }}
              />
              <label style={{ marginLeft: '8px' }}>진동 알람 사용</label>
            </div>
            <div style={{ marginTop: '10px' }}>
              <input
                type="checkbox"
                checked={JkVbV1SettingData.SetAlarmYUse === 1}
                onChange={async (e) => {
                  const value = e.target.checked ? 1 : 0;
                  dispatch(updateJkVbV1SettingData({ SetAlarmYUse: value }));
                  try {
                    const response = await axios.post(`${config.backendUrl}/api/SettingJkVbV1`, { SetAlarmYUse: value, type: 'Y' });
                    alert("기울기 알람 설정 성공");
                    dispatch(fetchSettings());
                  } catch (error) {
                    alert("기울기 알람 설정 실패");
                  }
                }}
              />
              <label style={{ marginLeft: '8px' }}>기울기 알람 사용</label>
            </div>
          </div>

          {/* 진동 경보 설정 */}
          <h5>진동 경보 설정 (경계 [MAX] 초과는 위험으로 처리)</h5>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
            {/* 주의, 경계, 위험 입력 필드들... */}
            {['최소', '~주의 [MAX]', '~경계 [MAX]'].map((label, index) => {
              const fieldMap = {
                '최소': 'SetLevelALow',
                '~주의 [MAX]': 'SetLevelAMid',
                '~경계 [MAX]': 'SetLevelAHigh'
              };
              const field = fieldMap[label];

              return (
                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <label>{label}</label>
                  <input
                    type="text"
                    pattern="[0-9]*([.,][0-9]{2})?"
                    value={JkVbV1SettingData[field]}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;
                      dispatch(updateJkVbV1SettingData({ [field]: value }));
                    }}
                    placeholder="00.00"
                    style={{
                      width: '120px',
                      height: '30px',
                      padding: '5px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      textAlign: 'center'
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* 기울기 경보 설정 */}
          <h5>기울기 경보 설정 (경계 [MAX] 초과는 위험으로 처리)</h5>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
            {/* 주의, 경계, 위험 입력 필드들... */}
            {['최소', '~주의 [MAX]', '~경계 [MAX]'].map((label, index) => {
              const fieldMap = {
                '최소': 'SetLevelYLow',
                '~주의 [MAX]': 'SetLevelYMid',
                '~경계 [MAX]': 'SetLevelYHigh'
              };
              const field = fieldMap[label];

              return (
                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <label>{label}</label>
                  <input
                    type="text"
                    pattern="[0-9]*([.,][0-9]{2})?"
                    value={JkVbV1SettingData[field]}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;
                      dispatch(updateJkVbV1SettingData({ [field]: value }));
                    }}
                    placeholder="00.00"
                    style={{
                      width: '120px',
                      height: '30px',
                      padding: '5px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      textAlign: 'center'
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* 기준값 초과 알람 설정 */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <label>기준값 초과 알람 횟수 설정</label>
              <input
                type="text"
                pattern="[0-9]*"
                value={JkVbV1SettingData.SetAlarmCount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!/^\d*$/.test(value)) return;
                  dispatch(updateJkVbV1SettingData({ SetAlarmCount: value }));
                }}
                placeholder="1"
                style={{
                  width: '120px',
                  height: '30px',
                  padding: '5px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  textAlign: 'center'
                }}
              />
            </div>
          </div>
          {/* 문자 보내기 연락처 */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', margin: '20px' }}>
            <label>문자 보내기 연락처</label>
            <input
              type="text"
              value={JkVbV1SettingData.SMS_Number_Setting || ''}
              onChange={(e) => {
                const value = e.target.value;
                // 숫자와 하이픈만 허용
                const sanitizedValue = value.replace(/[^\d-]/g, '');
                dispatch(updateJkVbV1SettingData({ SMS_Number_Setting: sanitizedValue }));
              }}
              placeholder="010-1234-5678"
              style={{
                width: '200px',
                height: '30px',
                padding: '5px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                textAlign: 'center'
              }}
            />
          </div>
          {/* 발신 번호 [서비스등록번호] */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', margin: '20px' }}>
            <label>발신 번호 (서비스등록번호)</label>
            <input
              type="text"
              value={JkVbV1SettingData.SMS_Callback_Number || ''}
              onChange={(e) => {
                const value = e.target.value;
                // 숫자와 하이픈만 허용
                const SMS_Callback_Number_Value = value.replace(/[^\d-]/g, '');
                dispatch(updateJkVbV1SettingData({ SMS_Callback_Number: SMS_Callback_Number_Value }));
              }}
              placeholder="010-1234-5678"
              style={{
                width: '200px',
                height: '30px',
                padding: '5px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                textAlign: 'center'
              }}
            />
          </div>
          {/*SMS API키입력  */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', margin: '20px' }}>
            <label>SMS서비스-API키입력</label>
            <input
              type="text"
              value={JkVbV1SettingData.SMS_Api_Key || ''}
              onChange={(e) => {
                const value = e.target.value;
                // 문자와 숫자만 허용
                const SMS_Api_Key_Value = value.replace(/[^\w]/g, '');
                dispatch(updateJkVbV1SettingData({ SMS_Api_Key: SMS_Api_Key_Value }));
              }}
              placeholder="API키를 입력하세요"
              style={{
                width: '200px',
                height: '30px',
                padding: '5px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                textAlign: 'center'
              }}
            />
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          취소
        </Button>
        <Button
          variant="primary"
          onClick={async () => {
            try {
              const response = await axios.post(`${config.backendUrl}/api/SettingJkVbV1`, {
                SetLevelALow: JkVbV1SettingData.SetLevelALow,
                SetLevelAMid: JkVbV1SettingData.SetLevelAMid,
                SetLevelAHigh: JkVbV1SettingData.SetLevelAHigh,
                SetLevelYLow: JkVbV1SettingData.SetLevelYLow,
                SetLevelYMid: JkVbV1SettingData.SetLevelYMid,
                SetLevelYHigh: JkVbV1SettingData.SetLevelYHigh,
                SetAlarmCount: JkVbV1SettingData.SetAlarmCount,
                SMS_Number_Setting: JkVbV1SettingData.SMS_Number_Setting,
                SMS_Api_Key: JkVbV1SettingData.SMS_Api_Key,
                SMS_Callback_Number: JkVbV1SettingData.SMS_Callback_Number,
                type: 'SetLevel',
              });
              alert("경보 설정 저장 성공");
              onHide();
            } catch (error) {
              alert("경보 설정 저장 실패");
            }
          }}
        >
          저장
        </Button>
      </Modal.Footer>
    </Modal>
  );
}




export default VibrationDetection;
